import { createAsyncThunk } from '@reduxjs/toolkit';
import GoalOptimizerApi, {
  GoalOptimizerExplainRequest,
  GoalOptimizerExplainResponse,
  GoalOptimizerParaphraseRequest,
  GoalOptimizerParaphraseResponse,
  GoalOptimizerRecommendationResponse,
} from 'api/GoalOptimizerApi';

export const createRecommendThunk = (api: GoalOptimizerApi) =>
  createAsyncThunk('goalOptimizer/recommend', async ({ applicationId }: { applicationId: string }, thunkApi) => {
    try {
      const response: GoalOptimizerRecommendationResponse = await api.recommend(applicationId);
      return response;
    } catch (error: any) {
      const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
      return thunkApi.rejectWithValue(payload);
    }
  });

export const createExplainThunk = (api: GoalOptimizerApi) =>
  createAsyncThunk(
    'goalOptimizer/explain',
    async (
      {
        applicationId,
        actionText,
        recommendedGoalType,
        recommendedGoalTypeSecondary,
        topicsCovered,
      }: GoalOptimizerExplainRequest,
      thunkApi,
    ) => {
      try {
        const response: GoalOptimizerExplainResponse = await api.explain({
          applicationId,
          actionText,
          recommendedGoalType,
          recommendedGoalTypeSecondary,
          topicsCovered,
        });
        return response;
      } catch (error: any) {
        const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
        return thunkApi.rejectWithValue(payload);
      }
    },
  );

export const createParaphraseThunk = (api: GoalOptimizerApi) =>
  createAsyncThunk(
    'goalOptimizer/paraphrase',
    async ({ applicationId, text }: GoalOptimizerParaphraseRequest, thunkApi) => {
      try {
        const response: GoalOptimizerParaphraseResponse = await api.paraphrase({
          applicationId,
          text,
        });
        return response;
      } catch (error: any) {
        const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
        return thunkApi.rejectWithValue(payload);
      }
    },
  );
